<script>
    import Vue from 'vue'
    import config from '../libs/config.json';
    import Leftbar from '../components/dashboard/leftBar.vue';
    import  NewWorkspace  from "../components/dashboard/CreateWorkspace.vue";
    import  CreateTag  from "../components/dashboard/CreateTag.vue";
    import  EditUser  from "../components/dashboard/EditUser.vue";
    import  UpgradeModal  from "../components/dashboard/UpgradePlan.vue";
    import  PricingModal  from "../components/dashboard/Pricing.vue";
    import  AutomationRulesModal  from "../components/dashboard/automationRules.vue";
    import  searchModal  from "../components/dashboard/search.vue";
    import Axios from 'axios'
    import AOS from 'aos'
    import api from '../api'
    import _ from 'lodash'
    import 'aos/dist/aos.css'

    import iziToast from 'izitoast'
    import 'izitoast/dist/css/iziToast.min.css';

    import func from '../libs/functions.js';

    import _system from '../libs/system'

    import { db, storage } from '../firebase';

    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: "sidebarView",
        data(){
            return {
                func:func,
                currentPath: '',
                loadingInvitation: false,
                iziToast: iziToast,
                notification: true
            }
        },
        components: {
            Leftbar,
            NewWorkspace,
            EditUser,
            CreateTag,
            PricingModal,
            searchModal,
            AutomationRulesModal,
            UpgradeModal
        },
        watch: {
            $route (to, from) {
                this.currentPath = this.$router.history.current.path;
            }
            },
        computed: {
            ...mapGetters('session', ['isLoggedIn', 'getUser', 'getJwt', 'getWhiteLabel']),
            ...mapGetters('loading', ['loadingApp']),
            ...mapGetters('accounts', ['accounts']),
            ...mapGetters('workspaces', ['workspaces', 'currentWorkspace', 'invitedWorkspaces']),
            ...mapGetters('networks', ['networks']),
            ...mapGetters('mobileMenu', ['leftMobileMenu', 'rightMobileMenu']),
            ...mapGetters('menu', ['miniMenu']),
            ...mapGetters('tags', ['tags', 'tagsByName', 'tagsById']),
            ...mapGetters('htmlModals', ['modals']),
            ...mapGetters("workspaceusers", ["workspaceusers"]),
            ...mapGetters("subscriptions", ["getPaypalSubscriptions"])
        },methods : {
            ...mapActions('session', ['setRole', 'setUserDb', 'setWhiteLabel']),
            ...mapActions('statuses', ['setStatuses']),
            ...mapActions('loading', ['setLoadingApp', 'setLoadingAppReRender']),
            ...mapActions('tags', ['setTags']),
            ...mapActions('accounts', ['setAccounts', 'setWorkspaceAccounts']),
            ...mapActions('networks', ['setNetworks']),
            ...mapActions('workspaces', ['setWorkspaces', 'pushWorkspace', 'setInvitedWorkspaces', 'setCurrentWorkspaceSettings', 'setCurrentWorkspace']),
            ...mapActions('workspaceusers', ['setWorkspaceusers']),
            ...mapActions('mobileMenu', ['toggleLeftMenu','toggleRightMenu']),
            ...mapActions('plans', ['setPlans']),
            ...mapActions('subscriptions', ['setSubscriptions']),
            acceptInvitation(workspaceuser){
              this.loadingInvitation = true;
                let payload = {
                    query: {
                        userId: this.getUser._id
                    },
                    body:{
                        workspace: workspaceuser.workspace._id
                    }
                };
                _system.services.user.updatePreferencesForWorkspace(payload, (err, result) => {
                    if(err) console.log(err)

                    this.setCurrentWorkspace(workspaceuser.workspace)

                    _system.services.workspaceusers.deleteTag({workspaceuserId: workspaceuser._id, tagId: this.tagsByName['Invited']._id }, (err, data) => {
                        this.loadingInvitation = false;
                        window.location.reload();
                            //this.setLoadingApp(true);
                            //this.setLoadingAppReRender(true);
                    });

                });

      
            },
            declineInvitation(workspaceuser){
                _system.services.workspaceusers.deleteWorkspaceUser({workspaceuserId: workspaceuser._id }, (err, data) => {
                          this.setLoadingApp(true);
                          this.setLoadingAppReRender(true);
                })
                //this.pushWorkspace(workspace)
            },
            activateNotification(){
                    Notification.requestPermission().then(function (permission) {
                        // If the user accepts, let's create a notification
                        if (permission === "granted") {
                            var notification = new Notification("Notifications Activated 🎉");
                            this.notification = false;
                        }else{
                            this.notification = false;
                            alert("Unfotunetely, I can't send new message notifications now :(");
                        }
                    });
            }
        },
        mounted(){


        let domain = window.location.hostname.toString();
        //if(domain == 'app.juphy.com' || domain == 'localhost') this.setWhiteLabel(false);
        if(domain == 'app.juphy.com' || domain == 'localhost' || domain.includes('ngrok')) this.setWhiteLabel(false);


/*             window.heap.addUserProperties({'name': this.getUser.name,'email': this.getUser.email});
            window.heap.identify(this.getUser.email); */
        
/*         window.socket.on('users', (data) => { 
          console.log(data);
          for (const dat of data) {
             let index = _.findIndex(this.workspaceusers, { user: { _id:  dat._id }});
            if(index !== -1){
              let staticObject = Object.assign({}, this.workspaceusers[index])
              staticObject.online = true;
              this.$set(this.workspaceusers, index, staticObject);
            }
          }
        }); */



        },
        created(){
      
            //if(Notification.permission === "granted") this.notification = false
            AOS.init();


             
                        let payload = {
                            query: {
                                productName: 'Juphy - Per Member V2'
                            }
                        }
                        _system.services.stripe.getPlansByProductName(payload, (err, plans) => {
                         
                            this.setPlans(plans);
                        })

                        payload = {
                            query: {
                                userId: this.getUser._id
                            }
                        }

                        _system.services.user.getUserById(payload, (err, userFromDb) => {
                            if (err) console.log(err)

                            this.setUserDb(userFromDb);


                        //_system.services.subscriptions.getSubscriptions(payload, (err, subscriptions) => {
                        //if(err) return window.location.href = '/logout'

/*                         this.setSubscriptions(_.chain(_.defaultTo(subscriptions, [])).map( s => ({ package: s.plan.metadata.name, amount: parseInt(s.plan.amount), currency: s.plan.currency, channelLimit: parseInt(s.plan.metadata.channelLimit), userLimit: s.plan.metadata.userLimit })).value()); */


                        _system.services.networks.get((err, data) => {
                            if(err) return window.location.href = '/logout'
                                this.setNetworks(data);

                            _system.services.workspaceusers.getByUsers({ _id : this.getUser._id }, (err, workspaceusers) => {
                                if(workspaceusers.length < 1) return window.location.href = '/logout'

                                let arrayWorkspaces = _.map( workspaceusers, 'workspace');

                                this.setWorkspaces(arrayWorkspaces);

                                //Specify Current Workspace START
                                let currentWorkspace = {};                    
                                let currentWorkspaceFromLocalStorage = localStorage.getItem('currentWorkspace'+ this.getUser.email) && JSON.parse(localStorage.getItem('currentWorkspace'+ this.getUser.email));
                                let currentWorkspaceFromDatabase = (() => {
                                    if(userFromDb.preferences && userFromDb.preferences.workspace){
                                        return _.find(arrayWorkspaces, { _id: userFromDb.preferences.workspace})
                                    }else{
                                        return null
                                    }
                                })();

                                if(currentWorkspaceFromDatabase){
                                    //console.log('From DB');
                                    currentWorkspace = currentWorkspaceFromDatabase
                                }else if(currentWorkspaceFromLocalStorage){
                                    //console.log('From LocalStorage');
                                    currentWorkspace = currentWorkspaceFromLocalStorage
                                }else{
                                    //console.log('From Vanilla');
                                    currentWorkspace = arrayWorkspaces[arrayWorkspaces.length-1]
                                }
                                
                                this.setCurrentWorkspace(currentWorkspace)      
                                //Specify Current Workspace END                  
                           
                                let payload = {
                                    query: {
                                        workspaceId: currentWorkspace._id
                                    }
                                }
                                _system.services.tags.get( payload, (err, tags) => {
                                    //if(err) return window.location.href = '/logout'
                                if(currentWorkspace.userTags && currentWorkspace.userTags.length){
                                    this.setTags(tags.concat(currentWorkspace.userTags));
                                }else{
                                    this.setTags(tags);
                                }
                                
                                this.setStatuses(_.filter(tags, {'type': { name: 'MessageStatus' }}));

                                this.setInvitedWorkspaces(workspaceusers);
                                
                                var currentUser = _.find(workspaceusers, (workspaceuser) => workspaceuser.workspace._id == currentWorkspace._id && workspaceuser.user._id == this.getUser._id );

                                let sessionedUserRole; 
                    
                                if(currentUser.tags.indexOf(this.tagsByName['Moderator']._id) != -1) {
                                    sessionedUserRole = this.tagsByName['Moderator']
                                } 
                                if(currentUser.tags.indexOf(this.tagsByName['Admin']._id) != -1) {
                                    sessionedUserRole = this.tagsByName['Admin']
                                } 
                                if(currentUser.tags.indexOf(this.tagsByName['Read Only']._id) != -1) {
                                    sessionedUserRole = this.tagsByName['Read Only']
                                } 
                                
                                this.setRole(sessionedUserRole);

                                    this.setAccounts(currentUser.pages);

                                            _system.services.workspaceusers.get({ _id : currentWorkspace._id }, (err, workspaceusers) => { 
    
                                            this.setWorkspaceusers(workspaceusers); 

                                            let getAdminsAccounts = _.find(workspaceusers, (workspaceuser) => {
                                                if(workspaceuser.tags.includes(this.tagsByName['Admin']._id)) return workspaceuser
                                            });
                                            
                                            this.setWorkspaceAccounts(getAdminsAccounts.pages);

                                                    if(!userFromDb.payments || userFromDb.payments && !userFromDb.payments.length){
                                                    this.currentWorkspace.pricingPlan = 'Trial'
                                                            this.currentWorkspace.purchases = []
                                                            this.setCurrentWorkspace(this.currentWorkspace);
                                                    }


                                                    db.collection('workspaces')
                                                    .doc(this.currentWorkspace._id)
                                                    .get()
                                                    .then(snapshot => {
                                                    const workspacePermissions = snapshot.data()

                                                        workspacePermissions.loaded = true
                                                        this.setCurrentWorkspaceSettings(workspacePermissions)
                                                        this.setLoadingApp(false);
                                                    }).catch(()=>{
                                                        this.setCurrentWorkspaceSettings({ loaded: true })
                                                        this.setLoadingApp(false);
                                                    })





/*                                                   let payload = {
                                                        query: {
                                                            userId: _.get(getAdminsAccounts, 'user._id', this.getUser._id)
                                                        }
                                                    }
                                                    

                                                    _system.services.stripe.getPurchases(payload, (err, purchases) => {
                                                        if(err) purchases = []

                                                       
                                                        if(purchases.length){
                                                            this.currentWorkspace.pricingPlan = 'Business'
                                                            this.currentWorkspace.purchases = purchases
                                                            this.setCurrentWorkspace(this.currentWorkspace);
                                                            this.setLoadingApp(false);
                                                        }else{
                                                            this.currentWorkspace.pricingPlan = 'Trial'
                                                            this.currentWorkspace.purchases = []
                                                            this.setCurrentWorkspace(this.currentWorkspace);
                                                            this.setLoadingApp(false);
                                                        }

                                                    }); */



                                            
                                  

                                            //Socket integration starts here
                                            const accessToken = this.getJwt;
                                            const workspaceId = this.currentWorkspace._id;

                                            window.io = io.connect('https://routines.juphy.com', {
                                                query: { accessToken, workspaceId },
                                                transports: ['websocket'],
                                                multiplex: false,
                                                secure: true,
                                                upgrade: false
                                            });

                                            })

                                })

                        })
                    })
            });

            //});
        }
    }
    
</script>



<template>
<span>


<NewWorkspace v-if="!loadingApp && modals.createWorkspace"></NewWorkspace>

<searchModal v-if="!loadingApp && modals.searchModal"></searchModal>

<CreateTag v-if="!loadingApp && modals.createTag"></CreateTag>

<EditUser v-if="!loadingApp && modals.editUser"></EditUser>

<PricingModal v-if="!loadingApp && modals.pricingModal"></PricingModal>

<UpgradeModal v-if="!loadingApp && modals.upgradeModal"></UpgradeModal>

<AutomationRulesModal v-if="!loadingApp && modals.automationRules"></AutomationRulesModal>

<AutomationRulesModal v-if="!loadingApp && modals.automationRules"></AutomationRulesModal>

<div v-if="!loadingApp && invitedWorkspaces.length">
    <div style="background: rgba(234, 204, 132, 0.9); z-index: 999999999999999; position: fixed; left: 0; right: 0; top: 0; bottom: 0;"></div>
    <div style="background: rgb(255, 223, 116) none repeat scroll 0% 0%;box-shadow: 1px 1px 10px rgba(0,0,0,0.2);z-index: 999999999999999999; position: fixed; right:0; left: 0;" class="ui grid padded">
    <div class="ui container">
        <div  v-for="item in invitedWorkspaces" :key="item._id" style="width:100%; background: transparent;" class="ui visible big message">
            <p style="color: rgb(63, 51, 45); text-align:center;"> <i class="bell icon"></i>  You are invited to  <b>{{item.workspace.name}}</b> 
            <a @click="acceptInvitation(item)" style="margin-left:15px; background: #333;" :class="(loadingInvitation) ? 'ui black button loading disabled' : 'ui black button' ">Accept</a>
            <a @click="declineInvitation(item)" style="background: transparent;"  :class="(loadingInvitation) ? 'ui button loading disabled' : 'ui button' ">Decline</a>
            </p>
        </div>
    </div>
    </div>
</div>

        <div v-if="loadingApp" style="height:100%;" class="ui grid centered middle aligned stackable">
            <div class="six wide computer sixteen wide mobile column">
                <div class="ui basic segment center aligned">
                <div style="padding:0;" class="ui basic segment padded">
                <img v-if="!getWhiteLabel" class="ui image centered" style="width: 55px;" src="/img/logo.png" alt="">
                </div>
                <div style="padding:0; color: #666;" class="ui basic segment loadingDots">
                    Loading
                </div>
                <div class="loader-inner ball-beat"><div></div><div></div><div></div></div>
                </div>
            </div>
        </div>


        <div style="background:#425DBC;" class="ui mobile only grid">
            <div v-if="isLoggedIn && !loadingApp" class="sixteen wide column">
                <div style="background:#425DBC;" class="ui huge icon inverted menu">
                <a @click="toggleLeftMenu((!leftMobileMenu) ? true : false); " class="item">
                    <i class="sidebar icon"></i>
                </a>
<!--                 <img style="width: 125px; height: 48px; padding: 10px;" class="item" :src="'/img/logo_dark2.png'" alt=""> -->
                    <div class="right menu">
                    <a @click="toggleRightMenu((!rightMobileMenu) ? true : false)" class="item">
                        <i class="filter icon"></i>
                    </a>
                    </div>
                </div>
            </div>
        </div>



        <div style="min-height: 100%" class="ui stackable grid padded">
          
           <div v-if="!loadingApp" style="background: #f9f9f9; transition: 0.5s;" v-bind:class="(currentPath == '/tracking') ? 'sixteen wide column' : 'sixteen wide stretched column' ">
                <slot />    
            </div>

        </div>

    </span>
</template>
<style scope>
.cloud {
position: fixed;
background: rgba(255, 255, 255, 0.88) none repeat scroll 0% 0%;
left: 0px;
top: 0px;
bottom: 0px;
right: 0px;
z-index: 999;
}


.loadingDots:after {
  content: ' .';
  animation: dots 0.2s steps(2, end) infinite;}

@keyframes dots {
  0%, 20% {
    color: rgba(0,0,0,0);
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);}
  40% {
    color: white;
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);}
  60% {
    text-shadow:
      .25em 0 0 white,
      .5em 0 0 rgba(0,0,0,0);}
  80%, 100% {
    text-shadow:
      .25em 0 0 white,
      .5em 0 0 white;}}

</style>



// WEBPACK FOOTER //
// src/layouts/onepageView.vue